import { cx } from "@emotion/css";
import type { FC, InputHTMLAttributes, ReactNode } from "react";
import type { UseFormRegisterReturn } from "react-hook-form";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  register: UseFormRegisterReturn<any>;
  helper?: ReactNode;
  styleType?: "shadow" | "outline";
}
export const Input: FC<InputProps> = ({ register, className, helper, styleType = "outline", ...props }) => {
  return (
    <div className="flex flex-col">
      <input
        className={cx([
          "form-input rounded-lg outline-0",
          styleType === "shadow"
            ? "text-[15px] leading-[23px] placeholder:font-normal placeholder:text-[14px] placeholder:leading-[22px] placeholder:text-[#404040] focus:border-[#737373] focus:shadow-none focus:ring-0 focus:ring-offset-0"
            : "text-[15px] leading-[23px] placeholder:text-text-gray focus:border-transparent focus:ring-primary",
          {
            "box-border h-[56px] border border-solid border-[#737373] bg-[#F2F4F5] px-3 py-[16.5px]":
              styleType === "shadow",
            "border-solid border-[#E3E5E5] px-3 pb-[10px] pt-[13px]": styleType === "outline",
          },
          props.disabled || "pr-8",
          props.disabled && "bg-[#F7F9FA]",
          className,
        ])}
        style={{ boxShadow: "0 0 #0000" }}
        {...props}
        {...register}
      />

      {helper && (
        <div
          className={cx(
            "mt-2",
            styleType === "shadow"
              ? "text-[14px] font-normal leading-[22px] text-[#404040]"
              : "text-[15px] text-text-gray"
          )}
        >
          {helper}
        </div>
      )}
    </div>
  );
};
